import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { HolidayDateModel, HolidayModel } from '@core/services/holiday/holiday.model';
import { HolidayService } from '@core/services/holiday/holiday.service';
import { process } from '@progress/kendo-data-query';
import { ConfirmDialogComponent } from '@shared/components/confirm-dialog/confirm-dialog.component';
import { GridSettings } from '@shared/components/customized-grid/grid-settings/gird-settings.interface';
import { NgxSpinnerService } from 'ngx-spinner';
import { HolidayDateAddEditComponent } from './holiday-date-add-edit/holiday-date-add-edit.component';

@Component({
  selector: 'Teranet-HolidayDate',
  templateUrl: './holiday-date.component.html'
})
export class HolidayDateComponent implements OnInit {
  gridSettings: GridSettings;
  holidayDateFormGroup: FormGroup;
  holidayDateModels: HolidayDateModel[] = [];
  holidayModels: HolidayModel[] = [];
  services: any;

  constructor(
    private dialog: MatDialog,
    private holidayService: HolidayService,
    private spinner: NgxSpinnerService,
  ) {
    this.holidayDateFormGroup = new FormGroup({
      year: new FormControl('', Validators.required),
    });
  }

  public state: any = {
    skip: 0,
    take: 13,
    filter: {
      logic: 'and',
      filters: [],
    },
  };

  ngOnInit() {
    this.gridSettings = this.gridDefaultSettings();
  }

  addHolidayDate() {
    const dialogRef = this.dialog.open(HolidayDateAddEditComponent, {
      data: null,
      width: '550px',
    });

    dialogRef.afterClosed().subscribe(() => { });
  }

  getHolidays() {
    this.spinner.show();
    this.holidayService.getHolidays().subscribe(result => {
      if (result) {
        this.holidayModels = result;
        this.gridSettings.gridData = { data: this.holidayModels, total: this.holidayModels.length };
      }
      this.spinner.hide();
    });
  }

  onDelete(row: HolidayDateModel) {
    let dialog =
      this.services && this.services[0] ? this.services[0] : null;

    let holidayService =
      this.services && this.services[1] ? this.services[1] : null;

    const dialogRef = dialog.open(ConfirmDialogComponent, {
      data: { message: `Do you want to delete the ${row.description} holiday date?` },
      width: '350px',
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        holidayService.deleteHolidayDate(row.id).subscribe(() => { });
      }
    });
  }

  onEdit(row: HolidayDateModel) {
    let dialog = this.services && this.services[0] ? this.services[0] : this != null ? this.dialog : null;

    const dialogRef = dialog.open(HolidayDateAddEditComponent, {
      data: row,
      width: '550px',
    });

    dialogRef.afterClosed().subscribe(() => { });
  }

  onLookup() {
    if (this.holidayDateFormGroup.valid) {
      this.refresh(this.holidayDateFormGroup.get('year').value);
    }
  }

  refresh(year: string) {
    this.spinner.show();
    this.holidayDateModels = [];
    this.holidayService.getHolidayDates(year).subscribe(result => {
      if (result) {
        this.holidayDateModels = result;
      }
      this.spinner.hide()
    });
  }

  gridDefaultSettings(): GridSettings {
    return {
      state: this.state,
      gridData: process(this.holidayDateModels, this.state),
      columnsConfig: [
        {
          field: 'year',
          filterable: true,
          hidden: false,
          title: 'Year',
          width: 150,
        },
        {
          field: 'date',
          filter: 'date',
          filterable: true,
          format: 'MM-dd',
          hidden: false,
          title: 'Date',
          type: 'date',
          width: 150,
        },
        {
          field: 'description',
          filterable: true,
          hidden: false,
          title: 'Description',
          width: 150,
        },
        {
          field: 'code',
          filterable: true,
          hidden: false,
          title: 'Holiday Code',
          width: 150,
        },
        {
          clickAction: this.onEdit,
          excludeFromExcel: true,
          field: 'id',
          filterable: false,
          hidden: false,
          icon: 'pen',
          includeInChooser: false,
          title: 'Edit',
          type: 'icon',
          services: [this.dialog],
          width: 40,
        },
        {
          clickAction: this.onDelete,
          excludeFromExcel: true,
          field: 'id',
          filterable: false,
          hidden: false,
          icon: 'trash-alt',
          includeInChooser: false,
          title: 'Delete',
          type: 'icon',
          services: [this.dialog, this.holidayService],
          width: 40,
        },
      ],
    };
  }
}
